import React from 'react';
import { useNavigate } from 'react-router-dom';
import { featuredServices } from '../mock';
import { ArrowUpRight, ArrowRight } from 'lucide-react';
import { TickList, ContactPromptCard } from './SharedUI';

export default function ServicesSection() {
  const navigate = useNavigate();

  return (
    <section id="services" className="section">
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-end',
          marginBottom: 56,
          gap: 24,
          flexWrap: 'wrap',
        }}
        className="reveal"
      >
        <div>
          <div className="section-label" style={{ marginBottom: 16 }}>
            04 &mdash; Services
          </div>
          <h2 className="section-title" style={{ margin: 0, maxWidth: 760 }}>
            Things I can<br /> build for you.
          </h2>
        </div>
        <p
          style={{
            color: 'rgba(245,245,245,0.55)',
            maxWidth: 420,
            fontSize: 15,
            lineHeight: 1.7,
          }}
        >
          A short menu of what I do best. Fast turnarounds, clean execution,
          and zero fluff &mdash; pick what you need and slide into my DMs.
        </p>
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
          gap: 20,
        }}
      >
        {featuredServices.map((s) => (
          <div
            key={s.id}
            className="glass-card reveal"
            style={{
              padding: 28,
              display: 'flex',
              flexDirection: 'column',
              gap: 16,
              cursor: 'pointer',
            }}
            onClick={() => navigate('/services')}
          >
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <span
                className="mono"
                style={{
                  fontSize: 10,
                  letterSpacing: '0.3em',
                  color: 'rgba(245,245,245,0.45)',
                  textTransform: 'uppercase',
                }}
              >
                {s.code}
              </span>
              <ArrowUpRight size={16} strokeWidth={1.5} color="rgba(245,245,245,0.55)" />
            </div>
            <h3
              style={{
                fontFamily: 'Space Grotesk, sans-serif',
                fontWeight: 500,
                fontSize: 24,
                margin: 0,
                letterSpacing: '-0.01em',
              }}
            >
              {s.title}
            </h3>
            <p style={{ color: 'rgba(245,245,245,0.65)', fontSize: 14, lineHeight: 1.6, margin: 0 }}>
              {s.short}
            </p>
            <TickList items={s.bullets} />
          </div>
        ))}

        {/* See more card */}
        <div className="see-more-card reveal" onClick={() => navigate('/services')}>
          <div
            className="mono"
            style={{
              fontSize: 10,
              letterSpacing: '0.35em',
              color: 'rgba(245,245,245,0.5)',
              textTransform: 'uppercase',
            }}
          >
            / Full menu
          </div>
          <h3
            style={{
              fontFamily: 'Space Grotesk, sans-serif',
              fontWeight: 500,
              fontSize: 22,
              margin: 0,
              letterSpacing: '-0.01em',
              color: '#f5f5f5',
            }}
          >
            See all services
          </h3>
          <p style={{ color: 'rgba(245,245,245,0.55)', fontSize: 13, lineHeight: 1.6, margin: 0, maxWidth: 220 }}>
            Posters, content, sites, edits & more &mdash; all on one page.
          </p>
          <span
            style={{
              marginTop: 8,
              display: 'inline-flex',
              alignItems: 'center',
              gap: 6,
              padding: '8px 14px',
              borderRadius: 999,
              background: '#f5f5f5',
              color: '#000',
              fontFamily: 'JetBrains Mono, monospace',
              fontSize: 10,
              letterSpacing: '0.3em',
              textTransform: 'uppercase',
            }}
          >
            Open <ArrowRight size={12} />
          </span>
        </div>
      </div>

      <ContactPromptCard message="Need something not listed? Just message me — I probably do it." />
    </section>
  );
}
